import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SystemTaskDataModel} from '../../../models/messaging/system-task-data.model';
import {TaskService} from 'src/app/services/task.service';
import {Globals} from '../../../globals';
import {AuthenticationService} from 'src/app/modules/auth/services/authentication.service';
import {TASK_STATUS, TASK_TYPE} from '../../../models/constants/task-type.model';
import {MessagingConstants} from '../../../models/MessagingConstants';
import {MessagingService} from '../../../services/messaging.service';
import {TdoNoteAssociatedObject, TdoNoteSaveModel} from '../tdo-notes/models/tdo-note-save-model';
import {NoteCategoryEnum} from '../../../models/enum/note-category.enum';
import {NoteTypeEnum} from '../../../models/enum/note-type.enum';
import {NotesService} from '../../../services/notes.service';
import {dataPatientCaseWorkItemEventModel} from '../../../models/Events/dataPatientCaseWorkItemEvent.model';
import {EVENT_TYPE} from '../../../models/enum/enum-WorkItem-Event-Type.enum';
import {SignalrService} from '../../../services/socket/signalr.service';
import {LocalStorageService} from '../../../services/local-storage.service';
import {Router} from '@angular/router';
import {TDOTaskListService} from "./tdo-task-list.service";
import { UiService } from 'src/app/services/ui.service';


@Component({
    selector: 'app-tdo-task-list',
    templateUrl: './tdo-task-list.component.html',
    styleUrls: ['./tdo-task-list.component.scss']
})
export class TdoTaskListComponent implements OnInit {
    @Input() isExpanded = true;
    //@Input() tasks: SystemTaskDataModel[] = [];
    @Output() newItemEvent = new EventEmitter<string>();
    //tasks: SystemTaskDataModel[] = [];
    tasks: any[] = [];
    callTasks: SystemTaskDataModel[] = [];
    reportTasks: SystemTaskDataModel[] = [];
    financeTasks: SystemTaskDataModel[] = [];
    selectedCaseItem: SystemTaskDataModel;
    taskEvent: dataPatientCaseWorkItemEventModel;
    public TASK_TYPE_Enum = TASK_TYPE;

    constructor(
        private taskService: TaskService,
        private globals: Globals,
        private messagingService: MessagingService,
        private noteService: NotesService,
        public authService: AuthenticationService,
        private signalrService: SignalrService,
        private localStorageService: LocalStorageService,
        private router: Router,
        public TaskListService: TDOTaskListService,
        private uiService: UiService
    ) {
    }

    ngOnInit(): void {
            if(this.TaskListService.tasks.getValue().length === 0) {
                this.TaskListService.loadTaskList();//.subscribe(data => {
              }
    }

    checkedTask(event: MouseEvent, model: SystemTaskDataModel) {
        // stop the click from unchecking the checkbox
        event.preventDefault();
        event.stopPropagation();
        this.selectedCaseItem = model;
        this.completeTask();
    }

    onCaseItemClick(model: SystemTaskDataModel) {
        this.selectedCaseItem = model;
        this.executeTaskAction();
    }

    executeTaskAction() {
        switch (this.selectedCaseItem.enumUserTaskTypeID) {
        case TASK_TYPE.USER_FollowUpCase:
        case TASK_TYPE.USER_FollowUpProcedure:
        case TASK_TYPE.USER_FollowUpPatient: 
        case TASK_TYPE.USER_FollowupPatientDueToCancelation:// Calls
            this.callTasksExecution();
            break;
        case TASK_TYPE.USER_ReviewReport: // Reports
            this.reportTaskExecution();
            break;
        case TASK_TYPE.USER_FollowUpAR: // Finances Follow Up AR - Patient
            this.financesTaskARPatientExecution();
            break;
        case TASK_TYPE.USER_FollowUpAR_Insurance: // Finances Follow Up AR - Insurance
            this.financesTaskARInsuranceExecution();
            break;
        }
    }

    callTasksExecution() {
        const PatientName = (this.parseJson(this.selectedCaseItem.ContentParametersJSON).PatientName);
        const Subject = (this.parseJson(this.selectedCaseItem.ContentParametersJSON).Subject);
        this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
            PatientID: this.selectedCaseItem.ObjectId,
            PatientName,
            clearCurrentQuery: false
        });

        // Create note
        const noteModel = new TdoNoteSaveModel();
        noteModel.associatedObjects = [];
        const as1 = new TdoNoteAssociatedObject();
        as1.parentObjectName = 'SystemTaskId';
        as1.objectId = this.selectedCaseItem.SystemTaskId;
        noteModel.associatedObjects.push(as1);
        noteModel.text = Subject;
        noteModel.typeEnumIds = [NoteTypeEnum.Patient];
        noteModel.categoryEnumIds = [NoteCategoryEnum.CallList];
        noteModel.patientId = this.selectedCaseItem.ObjectId;
        this.noteService.saveNote(noteModel).subscribe((res) => {
            this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, '');
        });

        // Create event:
        const PatientCaseId = (this.parseJson(this.selectedCaseItem.ContentParametersJSON).PatientCaseId);
        this.taskEvent = new dataPatientCaseWorkItemEventModel();
        this.taskEvent.LOCID = this.selectedCaseItem.LOCID;
        this.taskEvent.enumWorkItemEventTypeID = EVENT_TYPE.CallPatient;
        this.taskEvent.PatientCaseId = PatientCaseId;
        this.taskService.createTaskEvent(this.taskEvent).subscribe();

    }

    reportTaskExecution() {
        const PatientName = (this.parseJson(this.selectedCaseItem.ContentParametersJSON).PatientName);
        this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
            PatientID: this.selectedCaseItem.ObjectId,
            PatientName,
            clearCurrentQuery: false
        });
    }

    

    openMailCenter(event: MouseEvent, model: SystemTaskDataModel) {
        // stop the click from unchecking the checkbox
        this.selectedCaseItem = model;
        event.stopPropagation();

        const PatientName = (this.parseJson(this.selectedCaseItem.ContentParametersJSON).PatientName);
        this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
            PatientID: this.selectedCaseItem.ObjectId,
            PatientName,
            clearCurrentQuery: false
        });
        // Implement Letter/MailCenter
        setTimeout(() => {
            this.uiService.openLettersWindow({paramTaskMail : true});
        }, 2000);
    }

    financesTaskARPatientExecution() {
        const PatientName = (this.parseJson(this.selectedCaseItem.ContentParametersJSON).PatientName);
        const PatientID = (this.parseJson(this.selectedCaseItem.ContentParametersJSON).PatientID);
        // Set Patient
        if (PatientID !== undefined) {
            this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
                PatientID,
                PatientName,
                Process: MessagingConstants.PATIENT_CHANGE_STARTLEDGER,
                clearCurrentQuery: false
            });

            // open Ledger
            setTimeout(() => {
                this.router.navigateByUrl('landing/ledger');
            }, 2000);

            // create note
            const noteModel = new TdoNoteSaveModel();
            noteModel.associatedObjects = [];
            const as1 = new TdoNoteAssociatedObject();
            as1.parentObjectName = 'SystemTaskId';
            as1.objectId = this.selectedCaseItem.SystemTaskId;
            noteModel.associatedObjects.push(as1);
            noteModel.text = 'Follow UP AR - Patient';
            noteModel.typeEnumIds = [NoteTypeEnum.Patient];
            noteModel.categoryEnumIds = [NoteCategoryEnum.Ledger];
            noteModel.patientId = this.selectedCaseItem.ObjectId;
            this.noteService.saveNote(noteModel).subscribe((res) => {
                this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, '');
            });
        }
    }



    financesTaskARInsuranceExecution() {
        const PatientName = (this.parseJson(this.selectedCaseItem.ContentParametersJSON).PatientName);
        const PatientID = (this.parseJson(this.selectedCaseItem.ContentParametersJSON).PatientID);
        const TDOClaimNumber = (this.parseJson(this.selectedCaseItem.ContentParametersJSON).TDOClaimNumber).toString();

        if (PatientID !== undefined && TDOClaimNumber !== undefined) {
            this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
                PatientID,
                PatientName,
                clearCurrentQuery: false
            });
            // open Claim filter by ClaimNumber
            localStorage.setItem('TDOClaimNumber', TDOClaimNumber);

            setTimeout(() => {
                this.router.navigate(['landing/claims']);
            }, 2000);

            // create note
            const noteModel = new TdoNoteSaveModel();
            noteModel.associatedObjects = [];
            const as1 = new TdoNoteAssociatedObject();
            as1.parentObjectName = 'ARClaimID';
            as1.objectId = this.selectedCaseItem.ObjectId;
            noteModel.associatedObjects.push(as1);
            noteModel.text = 'Follow UP AR - Insurance - Claim No:' + TDOClaimNumber;
            noteModel.typeEnumIds = [NoteTypeEnum.Patient];
            noteModel.categoryEnumIds = [NoteCategoryEnum.Insurance];
            noteModel.patientId = PatientID;
            this.noteService.saveNote(noteModel).subscribe((res) => {
                this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, '');
            });
        }
    }


    completeTask() {
        this.selectedCaseItem.enumTaskStatusID = TASK_STATUS.Completed;
        this.taskService.updateTask(this.selectedCaseItem).subscribe(result => {
            if (result) { // remove task from list
              const indexTask: number = this.tasks.findIndex(x => x.SystemTaskId === this.selectedCaseItem.SystemTaskId);
             this.TaskListService.deleteTask(indexTask);
                if (this.selectedCaseItem.enumUserTaskTypeID === TASK_TYPE.USER_FollowUpCase || 
                    this.selectedCaseItem.enumUserTaskTypeID === TASK_TYPE.USER_FollowUpProcedure || 
                    this.selectedCaseItem.enumUserTaskTypeID === TASK_TYPE.USER_FollowUpPatient || 
                    this.selectedCaseItem.enumUserTaskTypeID === TASK_TYPE.USER_FollowupPatientDueToCancelation
                ) {
                    const index: number = this.TaskListService.callTasks.getValue().findIndex(x => x.SystemTaskId === this.selectedCaseItem.SystemTaskId);
                    this.TaskListService.deleteCallTask(index);
                }
                if (this.selectedCaseItem.enumUserTaskTypeID === TASK_TYPE.USER_ReviewReport) {
                    const index: number = this.reportTasks.findIndex(x => x.SystemTaskId === this.selectedCaseItem.SystemTaskId);
                    this.TaskListService.deleteReporTask(index);
                }
                if (this.selectedCaseItem.enumUserTaskTypeID === TASK_TYPE.USER_FollowUpAR || this.selectedCaseItem.enumUserTaskTypeID === TASK_TYPE.USER_FollowUpAR_Insurance) {
                    const index: number = this.financeTasks.findIndex(x => x.SystemTaskId === this.selectedCaseItem.SystemTaskId);
                    this.TaskListService.deleteFinanceTask(index);
                }
            }
        });
    }



    parseJson(jsonString: string) {
        return JSON.parse(jsonString.replace(/'/g, '"'));
    }

}


